import t from "@/lang/lang";
import { Dialog, DialogContent } from "@/shared/components/ui/dialog";
import {
  CommonDialogFooter,
  CommonDialogHeader,
  CommonDialogTrigger,
} from "@/shared/components/dialog/dialog-common";
import { Trash2 } from "lucide-react";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { useRelationshipsRelationshipDeleteMutation } from "@/services/backend/relationships/api/service";
import { useEffect, useState } from "react";
import { toast } from "sonner";

export function DeleteRelationshipDialog({
  relationshipId,
  onSuccess,
}: {
  relationshipId: string;
  onSuccess?: () => void;
}) {
  const [open, setOpen] = useState(false);
  const [deleteRelationship, { isLoading, error, isSuccess, reset }] =
    useRelationshipsRelationshipDeleteMutation();

  useEffect(() => {
    if (isSuccess) {
      reset();
      toast.success(t("Beziehung gelöscht"));
      if (onSuccess) onSuccess();
      setOpen(false);
    }
  }, [isSuccess, onSuccess, reset]);

  const doDelete = () => {
    if (isLoading) {
      return;
    }

    deleteRelationship({ id: relationshipId });
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <CommonDialogTrigger icon={Trash2} label="" variant="destructive" />
      <DialogContent>
        <CommonDialogHeader
          title={t("Beziehung löschen?")}
          description={t(
            "Die Beziehung und alle zugehörigen Sollstellungen werden gelöscht.",
          )}
        />
        <RTKQueryErrorAlert error={error} />
        <CommonDialogFooter
          isLoading={isLoading}
          onClickAction={doDelete}
          destructive
        />
      </DialogContent>
    </Dialog>
  );
}
